<template>
  <div class="contentsKey" :class="{ 'contentsKey--loading': loading }">
    <loader v-if="loading" />
    <slot :content="content" />
  </div>
</template>

<script>
import Loader from './Loader';

export default {
  name: 'ContentsKey',
  components: { Loader },
  props: {
    contentKey: {
      type: String,
      default: '',
    },
  },
  async fetch() {
    await this.getContent();
  },
  data() {
    return {
      content: null,
      loading: true,
    };
  },
  watch: {
    contentKey(val) {
      this.loading = true;
      this.getContent();
    },
  },
  methods: {
    async getContent() {
      try {
        const {
          data: { content },
        } = await this.$axios.get(
          `${this.$config.baseOfixApi}/e-commerce/v1/contents/${this.contentKey}`,
        );
        this.content = content ? content.content : null;
        this.loading = false;
      } catch {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.contentsKey {
  position: relative;
  &--loading {
    background-color: $cWhite;
    min-height: 200px;
    opacity: 0.6;
  }
}
</style>
